import { render, staticRenderFns } from "./LegalParameterEditor.vue?vue&type=template&id=1f649059&scoped=true"
import script from "./LegalParameterEditor.vue?vue&type=script&lang=js"
export * from "./LegalParameterEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f649059",
  null
  
)

export default component.exports